export default __webpack_public_path__ + "static/media/rubrics_dark.340305ce.svg";